<section class="academy-faq" aria-labelledby="faq-heading">
  <h2 class="academy-faq__heading" id="faq-heading">Frequently Asked Questions</h2>

  <div class="academy-faq__questions">
    @for (section of sections; track section.heading; let sIdx = $index) {
      <div class="academy-faq__column">
        <h3 class="academy-faq__section-heading">{{ section.heading }}</h3>

        <div class="academy-faq__items">
          @for (item of section.items; track item.question; let iIdx = $index) {
            <div
              class="academy-faq__item"
              [class.academy-faq__item--open]="isFaqOpen(faqKey(sIdx, iIdx))"
            >
              <button
                type="button"
                class="academy-faq__trigger"
                [id]="'faq-btn-' + faqKey(sIdx, iIdx)"
                [attr.aria-expanded]="isFaqOpen(faqKey(sIdx, iIdx))"
                [attr.aria-controls]="'faq-answer-' + faqKey(sIdx, iIdx)"
                (click)="toggleFaq(faqKey(sIdx, iIdx))"
              >
                <span>{{ item.question }}</span>
                <svg
                  class="academy-faq__chevron"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>

              @if (isFaqOpen(faqKey(sIdx, iIdx))) {
                <div
                  [id]="'faq-answer-' + faqKey(sIdx, iIdx)"
                  class="academy-faq__answer"
                  role="region"
                  [attr.aria-labelledby]="'faq-btn-' + faqKey(sIdx, iIdx)"
                >
                  <span [innerHTML]="item.answer"></span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</section>
